class Combination {
  constructor(combinationData = {}) {
    this.combinations = combinationData.combinations || 0;
    this.value = combinationData.value || null;
  }
}

export default Combination;
